module.exports = __webpack_public_path__ + "static/media/artist.bb804879.jpg";